@let specialMenus = this.specialMenus();
@let activeMenu = this.activeMenu();

<app-header
  class="header"
  coreActivitySection="Header"
  pageName="SpecialOffer"
  [backSwipe]="backSwipeConfig"
/>

@if (!activeMenu && specialMenus && specialMenus.length > 1) {
  <div class="buttons" coreActivitySection="SelectLanguage">
    @for (menu of specialMenus; track menu.id) {
      <button
        class="button"
        (click)="this.activeMenu.set(menu)"
        [coreUserActivityClickTracking]="menu.name.split(' ').join('') + 'OpenSpecialOffer'"
      >
        {{ 'languages.' + menu.language + '.label' | translate }}
      </button>
    }
  </div>
}

@if (activeMenu) {
  <app-scroll>
    <div class="pages" coreActivitySection="Menu">
      @for (url of activeMenu.pagesLocal; track url) {
        <core-menu-image [url]="url"/>
      }
    </div>
  </app-scroll>
}
